"use client";
import React, {useEffect, useState} from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import SDialogHeader from "@/app/_components/SDialogHeader/SDialogHeader";
import ComBG from "@/app/_components/ComBG/ComBG";
import RedeemAccountUI from "@/app/(redeem)/redeemAccount/RedeemAccountUI";
import ScrollableContainer from "@/app/_components/ScrollableContainer/ScrollableContainer";
import FontIcon from "../../_components/FontIcon/fontIcon";

interface RedeemAccountDialogProps extends SDialogProps {
    channelData: ResponseRedeemConfigData,
    channelCheckData: ResponseRedeemChannelCheckData
}

export const RedeemAccountDialogFC: React.FC<RedeemAccountDialogProps> = (props) => {
    const {fcKey, onClose, channelData,channelCheckData} = props;
    const {closeDialog} = useDialogMethods(fcKey);
    const [isOpen, setIsOpen] = useState(true);

    const onCloseDialog = () => {
        closeDialog();
        onClose?.();
    }

    // ========== 按钮点击逻辑 ==========
    const onClickBack = () => {
        onCloseDialog();
    };

    // ========== 渲染 UI ==========
    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Full"
            onClose={onClose}
        >
            <ComBG>
                <SDialogHeader
                    title="Redeem Account"
                    icon={<FontIcon
                        icon={'s-safety'}
                        style={{
                            color: '#ffffff',
                            marginRight: '0.2rem',
                        }}
                    />}
                    onClickBack={onClickBack}
                />
                <ScrollableContainer>
                    {/*<div style={{height:"1.6rem",width:"100%"}}></div>*/}
                    <RedeemAccountUI channelData={channelData} channelCheckData={channelCheckData}/>
                </ScrollableContainer>
            </ComBG>
        </SDialogFC>
    );
};
